var _style, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbeddedMercuryLampOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "14px",
    viewBox: "0 0 16.3 14",
    style: {
      enableBackground: "new 0 0 16.3 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Embedded Mercury Lamp Output") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 9.4,
    cy: 6.9,
    rx: 4.8,
    ry: 4.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 6.1,
    className: "st0",
    width: 2.2,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    className: "st0",
    width: 0.9,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 11.8,
    className: "st0",
    width: 0.9,
    height: 2.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 6,
    className: "st0",
    width: 4,
    height: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 4.5,
    className: "st0",
    width: 0.9,
    height: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedMercuryLampOutput);
export default __webpack_public_path__ + "static/media/EmbeddedMercuryLampOutput.2dab1818dd245f7c977de2eff5611234.svg";
export { ForwardRef as ReactComponent };